import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#Corpus40a)",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 1.23h-1v4H8v12.265a2.085 2.085 0 0 0-4.014.052L.984 28.785a5.797 5.797 0 0 0 2.707 6.52l.254.146c.332.19.687.334 1.055.426V40h2v-4.123c.348-.087.684-.22 1-.396v4.749h32v-27h-5v-4h-7v-4h-4v-4H13Zm-3 32.6v4.4h16v-31H10v17.75l1.016 3.805A5.797 5.797 0 0 1 10 33.829Zm18 4.4v-23h10v23H28Zm5-27v2h-5v-2h5Zm-11-6v-2h-8v2h8ZM6 18a.085.085 0 0 0-.082.063L2.916 29.301a3.797 3.797 0 0 0 1.774 4.27l.254.147a2.116 2.116 0 0 0 2.112 0l.255-.147a3.797 3.797 0 0 0 1.773-4.27L6.082 18.063A.085.085 0 0 0 6 18Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13 10.23h2v5h-2zm0 8h2v5h-2zm0 8h2v5h-2zm8-16h2v5h-2zm0 8h2v5h-2zm0 8h2v5h-2zm11-8h2v5h-2zm0 8h2v5h-2z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "Corpus40a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h40v40H0z"
        })
      })
    })]
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Corpus40 } from '@cian/ui-kit/icons';`, <br />
 * где 40 - это размер иконки в пикселях.
 */
export var Corpus40 = createIcon(IconComponent);